export interface DictionaryItem {
  dictionaryDefinitionId: number;
  id: number;
  name: string;
  deleted: boolean;
}

export function isDictionaryItem(object: any): boolean {
  return 'id' in object && 'name' in object && 'dictionaryDefinitionId' in object;
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/interfaces/dictionary-item.interface.ts